<template>
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <div class="page-top-wrap">
            <div class="top wrap clear">
                <h2 class="bold  float-left">클래스 게시판</h2><br>
                <p class="bold">{{classinfo.classname}}</p>
                <p class="font-14 mt-10">수업 문의, 학습자료, 과제 제출을 할 수 있는 게시판입니다. </p>
                <!-- <div class="pt-10">
                    <select>
                        <option>카테고리 전체</option>
                    </select>
                    <select class="ml-10">
                        <option>전체</option>
                    </select>
                </div> -->
            </div>
        </div>

        <div class="page-top-wrap-notice">
            <div class="notice-wrap">
               <div class="add-box">
                   <select v-model="info.category">
                       <option value="">카테고리 선택</option>
                       <option value="D">Daily Feedback</option>
                       <option value="E">학습자료</option>
                       <option value="N">공지</option>
                       <option value="Q">문의</option>
                       <option value="H">과제제출</option>
                       <option value="T">기타</option>
                   </select>
               </div>
               <div class="add-box">
                   <input type="text" placeholder="제목을 입력해 주세요." v-model="info.title"/>
                   <img src="../assets/img/file-icon.png" class="file" @click="fileCLick()"/>
                   <input type="file"  id="noticeFile" name="noticeFile" style="display:none" @change="noticeFileChange($event)" accept=".jpg, .png, .doc,.docx, .hwp, .pdf, .ppt, .pptx, .xls, .xlsx" multiple/>
               </div>
               <div class="add-box"  v-if="temp_noticefile1!='' || temp_noticefile2!='' || temp_noticefile3!=''">
                   <a href="#"  v-if="temp_noticefile1!=''"><img src="../assets/img/file-download.png" class="mr-10 down-img" />{{temp_noticefile1}}<span @click="doDelete(0)" style="color :red; cursor:pointer" class="ml-20">x</span></a><br v-if="temp_noticefile2!=''">
                   <a href="#"  v-if="temp_noticefile2!=''"><img src="../assets/img/file-download.png" class="mr-10 down-img" />{{temp_noticefile2}}<span @click="doDelete(1)" style="color :red; cursor:pointer" class="ml-20">x</span></a><br  v-if="temp_noticefile3!=''">
                   <a href="#"  v-if="temp_noticefile3!=''"><img src="../assets/img/file-download.png" class="mr-10 down-img" />{{temp_noticefile3}}<span @click="doDelete(2)" style="color :red; cursor:pointer" class="ml-20">x</span></a>
               </div>
               <div class="add-box">
                   <textarea placeholder="내용을 입력해 주세요" v-model="info.content"></textarea>
               </div>
            </div>
        </div>
        <div class="wrap pt-20">
            <button class="btn-base-white float-left" @click="cancel()">취소</button>
            <button class="btn-base float-right" @click="doSubmit()">글쓰기</button>
        </div>

    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
import router from "@/router";
export default {
    name: 'NoticeAdd',
    components: {
        Menu
    },
    props: {
        msg: String
    },
    data: () => ({
        pwVisible: false,
        tab: 1,
        info:{
            classid:"",
            bcode:"",
            noticeFile:"",
            category:"",
            title:"",
            content:""
        },
        temp_noticefile1 :"",
        temp_noticefile2 :"",
        temp_noticefile3 :"",
        classinfo:{}
    }),
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");
    },
    mounted() {
        //    this.doc_del_rendar();
        this.info.classid = this.$route.query.classid;
        this.getBocde();
        this.getClassInfo();

    },
    methods: {
        doDelete(index){
            var me = this;
            console.log(index);
            if(confirm("파일을 삭제하시겠습니까?") == true){
                if(index == 0){
                    me.temp_noticefile1 = "";
                }else if(index == 1){
                    me.temp_noticefile2 = "";
                    document.getElementById("noticeFile").files[1] = {};
                }else if(index == 2){
                    me.temp_noticefile3 = "";
                    document.getElementById("noticeFile").files[2] = {};
                }
            }
        },
        fileCLick(){
            var file = document.getElementById("noticeFile");
            file.click();
        },
        cancel:function(){
            location.href="/noticelist?classid="+this.info.classid;
        },
        getClassInfo: function () {
            var me = this;
            var params = {
                uidx: localStorage.getItem("uidx"),
            };
            this.axios.get(this.$store.state.host + '/rest/mobile/classinfo_new/' + me.info.classid, {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    me.classinfo = res.data;
                    console.log(me.classinfo);
                } else {
                    alert(res.data.err_msg);
                }
                me.is_loader = false;
            });
        },
        getBocde(){
            var me = this;
            console.log(me.info);
            var params = {
                classid:this.info.classid
            }
            this.axios.get(this.$store.state.host+"/rest/mobile/getBcode",{params:params}).then(function (res){
                // console.log(res.data);
                if(res.data.err == 0){
                    me.info.bcode = res.data.bcode;
                }else{
                    alert(res.data.err_msg);
                }
            });
        },
        noticeFileChange(event){
            console.log(event);
            // console.log(event.target.files[0].name);
            // alert("a");
            var fileext = event.target.files[0].name.slice(event.target.files[0].name.indexOf(".")+1).toLowerCase();
            // console.log(fileext);
                var mexSize = 2 * 1024 * 1024
            if(fileext == 'jpg' || fileext == 'png' || fileext=='doc' || fileext=='docx' || fileext == 'hwp' || fileext == 'pdf' || fileext == 'ppt' || fileext == 'pptx' || fileext == 'xls' || fileext == 'xlsx'){
                // this.info.noticeFile = event.target.files[0].name;
                if(event.target.files.length > 3){
                    alert("최대 3개의 파일까지 선택할수있습니다.");
                    return false;
                }
                for(var i = 0; i < event.target.files.length; i++){
                    if(event.target.files[i].size > mexSize){
                        alert("첨부파일 사이즈는 2MB 이내로 등록 가능합니다.");
                        return false;
                    }else{
                        if(i == 0){
                        this.temp_noticefile1 = event.target.files[i].name;
                        }else if(i == 1){
                            this.temp_noticefile2 = event.target.files[i].name;
                        }else if(i == 2){
                            this.temp_noticefile3 = event.target.files[i].name;
                        }
                        this.info.noticeFile += event.target.files[i].name + ",\n";
                    }
                }
            }else{
                alert("파일첨부는 jpg, png, word, hwp, pdf, ppt, xls 만 가능합니다. ");
                return false;
            }
        },
        changeTab(target) {
            this.tab = target;
        },
        doSubmit(){
            var me = this;
            if(me.info.category == ""){
                alert("카테고리를 선택해주세요.");
                return false;
            }
            if(me.info.title == ""){
                alert("제목을 입력해주세요.");
                return false;
            }
            if(me.info.content == ""){
                alert("내용을 입력해주세요.");
                return false;
            }
            // return false;

            if(confirm("입력하신 내용으로 글을 등록하시겠습니까?") == true){
                var formData = new FormData();
                formData.append("category",me.info.category);
                formData.append("title",me.info.title);
                formData.append("contents",me.info.content);
                for(var i = 0; i < document.getElementById("noticeFile").files.length; i++){
                    if(i == 0){
                        if(this.temp_noticefile1 != ""){
                            formData.append("upfile"+i,document.getElementById("noticeFile").files[i]);
                        }
                    }
                    if(i == 1){
                        if(this.temp_noticefile2 != ""){
                            formData.append("upfile"+i,document.getElementById("noticeFile").files[i]);
                        }
                    }
                    if(i == 2){
                        if(this.temp_noticefile3 != ""){
                            formData.append("upfile"+i,document.getElementById("noticeFile").files[i]);
                        }
                    }
                }

                formData.append("uidx",localStorage.getItem("uidx"));
                formData.append("tmr",Date.now());
                formData.append("classid",me.info.classid);
                formData.append("bcode",me.info.bcode);
                formData.append("accessKey",localStorage.getItem("accessKey"));
                this.axios.post(this.$store.state.host + "/rest/mobile/classboardsave_new",formData).then(function(res){
                    // console.log(res.data);
                    if(res.data.err == 0){
                        alert("게시글이 등록되었습니다.")
                        location.href="/noticeview?b_idx="+res.data.idx+"&bcode="+me.info.bcode+"&classid="+me.info.classid;
                    }else{
                        alert(res.data.err_msg);
                      if(res.data.err==213)
                        router.push("/login");
                    }
                });
            }

        }
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 60px;
    .floating-write{
        position: fixed;
        right: 0;
        cursor: pointer;
        bottom: 0;
    }
    .page-top-wrap {
        width: 90%;
        margin: 0 auto;
        // border-bottom: 10px solid #F5F5F5;
        max-width: 700px;

        .top {
            // padding-right: 20px;
            border-bottom: 10px solid #f5f5f5;;
            padding-bottom: 17px;
            padding-top: 70px;
            background: url("../assets/img/top-bg.png") no-repeat right -80px;
            background-size: 300px;
            position: relative;

            .my-reason {
                position: absolute;
                right: 0;
                bottom: 15%;
            }

            p {
                font-size: 16px;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
                margin-top: 20px;
            }

            div {
                select {
                    border: 1px solid var(--unnamed-color-53caff);
                    background: #FFFFFF 0% 0% no-repeat padding-box;
                    border: 1px solid #53CAFF;
                    border-radius: 4px;
                    opacity: 1;
                    color: #53CAFF;
                    ;
                }
            }
        }
        .wrap {
            width: 100%;
            max-width: 700px;
        }
    }

    .page-top {
        border-bottom: 1px solid #E9E9E9;

        .review-top {

            div {
                background: #F5F5F5 0% 0% no-repeat padding-box;
                border: 1px solid #E9E9E9;
                border-radius: 10px;
                opacity: 1;
                width: 95%;
                margin: 0 auto;
                box-sizing: border-box;
                padding-top: 19px;
                padding-bottom: 19px;

                p {
                    float: left;
                    text-align: center;

                    &:first-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #B7B7B7;
                        opacity: 1;
                    }

                    &:last-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .page-top-wrap-notice{
        width: 90%;
        margin: 0 auto;
        max-width: 700px;
        .none-notice{
            display: table;
            min-height: 300px;
            width: 100%;

            p {
                display: table-cell;
                vertical-align: middle;
                text-align: center;
                color: var(--unnamed-color-b7b7b7);
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0px;
                color: #B7B7B7;
                opacity: 1;
            }
        }
        .notice-wrap {
           .add-box{
               width: 100%;
               border-bottom: 1px solid #E9E9E9;
               padding-top: 15px;
               padding-bottom: 15px;
               padding-left: 20px;
               padding-right: 20px;
               position: relative;
               select{
                   width: 100%;
                   border: none;
                   font-size: 14px;
                    letter-spacing: 0px;
                    background: none;
                    background: white;
                    color: #000000;
                    opacity: 1;
               }
               input[type="text"], input[type="password"]{
                    border-radius: 0;
                    border-top: none;
                    border-right: none;
                    border-left: none;
                    border-bottom: none;
                    font-size: 16px;
                    padding: 0 10px;
                    padding-left: 5px;
                    width: 100%;
                }
                .file{
                    position: absolute;
                    right: 0;
                    right: 20px;
                    width: 20px;
                    cursor: pointer;
                }
                a{
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #53CAFF;
                    opacity: 1;
                }
                textarea{
                    width: 100%;
                    border: none;
                    height: 200px;
                    resize: none;
                    font-size: 16px;
                }
                img{
                    width: 25px;
                }
                img.down-img{
                    width: 14px;
                }
           }
        }
    }
}

.btn-base-white {
    padding: 5px;
}

.footer {
    position: static;
}

@media only screen and (max-width: 414px) {
    .class{
        width: 100%;
    }
    .class {
        
        .page-top-wrap-notice{
            width: 100%;
        }
        .page-top-wrap {
            width: 100%;
            .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;
            &.wrap {
                width: 100%;
                padding-left: 5%;
                max-width: none;
            }
        }
        }
    }
}
</style>
